import { Heading } from '@zillow/constellation-10';
import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const MobileDropdownMenuSubSectionTitle = styled(Heading)`
    font-size: 14px;
    line-height: 40px;
    color: ${token('colors.textDark')};
`;
